import styled from 'styled-components';
import { maxMobile, smMobile } from 'Utils/utilsStyle';
// import { retina } from 'Utils/utilsStyle';

const Wrapper = styled.div<{ diameterSm: string }>`
  /* overflow: hidden; */
  width: 440px;
  margin: 0px 25px 50px 25px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    margin: 0 0 20px 0;
  }
  .person-skeleton-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 110px;
    @media all and (max-width: ${maxMobile}) {
      margin-left: 155px;
    }
    @media all and (max-width: ${smMobile}) {
      margin-left: 120px;
    }
    .progress {
      height: 20px;
      width: 100%;
      margin-top: 10px;    
    }
    .group-1 {
      height: 20px;
      border-radius: 25px;
      width: 30%;
      margin-bottom: 10px;
      margin-top: 20px;
    }
    .group-1 {
      height: 20px;
      border-radius: 25px;
      width: 30%;
      margin-bottom: 10px;
      margin-top: 20px;
    }
  }
  .skeleton-box {
    height: 20px;
    border-radius: 25px;
    width: 50px;
  }
`;

type Props = {
  diameterSm?: string,
} & typeof defaultProps;

const defaultProps = {
  diameterSm: '',
};

const AffinitySkeleton = function AffinitySkeleton(props: Props) {
  const { diameterSm } = props;
  return (
    <Wrapper diameterSm={diameterSm} className="person-skeleton-loader">
      <div className="person-skeleton-wrapper">
        <span className="skeleton-box progress" />
        <span className="skeleton-box group-1" />
        <span className="skeleton-box group-2" />
      </div>
    </Wrapper>
  );
};

AffinitySkeleton.defaultProps = defaultProps;
export default AffinitySkeleton;
